import React from 'react';
import styled from 'react-emotion';
import { LoadingLine } from '@jetshop/ui/Loading/LoadingLine';
import { ProductPlaceholder } from '../Layout/ProductComponent';
import Layout from '../Layout/Layout';
import theme from '@jetshop/ui/utils/theme';

const StyledLoadingBar = styled(LoadingLine)`
  margin-bottom: 1rem;
`;

const PlaceholderProducts = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-top: 40px;
`;

const SubcategoryWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  ${theme('above.lg')} {
    ${p => p.theme.calculateWidth(4, 3)}
  }

  ${theme('between.sm-lg')} {
    ${p => p.theme.calculateWidth(3, 3)}
  }

  ${theme('below.sm')} {
    ${p => p.theme.calculateWidth(2, 3)}
  }

  margin-bottom: 3%;
`;

const SubcategoryImage = styled.div`
  width: 100%;
  background: #f5f5f5;
  padding-bottom: ${(7 / 12) * 100}%;
  margin-bottom: 10px;
`;

const CategoryPlaceholder = ({ rows, subcategories = 8, products = 8 }) => (
  <Layout>
    <StyledLoadingBar heightPx={30} widthRem={30} randomizeWidthBy={10} />
    <StyledLoadingBar
      count={rows}
      heightPx={10}
      widthRem={30}
      randomizeWidthBy={20}
    />

    <PlaceholderProducts>
      {Array.from({ length: subcategories }).map((_, i) => (
        <SubcategoryWrapper key={i}>
          <SubcategoryImage />
          <LoadingLine widthRem={8} randomizeWidthBy={2} heightPx={16} />
        </SubcategoryWrapper>
      ))}
    </PlaceholderProducts>
    <PlaceholderProducts>
      {Array.from({ length: products }).map((_, i) => (
        <ProductPlaceholder key={i} />
      ))}
    </PlaceholderProducts>
  </Layout>
);

export default CategoryPlaceholder;
